import React from 'react';
import { FinalFormField } from '../Form/FinalFormField';

import { InputProps, Input } from '../Input';
import { FinalFormFieldProps } from '../Form/types';

export const FinalFormInput = (args: FinalFormFieldProps & InputProps) => {
  return (
    <FinalFormField {...args}>
      {({ input, ...rest }: FinalFormFieldProps) => {
        return (
          <Input
            data-test-error={!!rest.hintError}
            data-test-error-message={rest.hintError}
            {...input}
            {...rest}
          />
        );
      }}
    </FinalFormField>
  );
};
